import { render, staticRenderFns } from "./CompetitionModal.vue?vue&type=template&id=79351226&scoped=true"
import script from "./CompetitionModal.vue?vue&type=script&lang=js"
export * from "./CompetitionModal.vue?vue&type=script&lang=js"
import style0 from "./CompetitionModal.vue?vue&type=style&index=0&id=79351226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79351226",
  null
  
)

export default component.exports